import { Card, Portal } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { Typography } from '~sharedUI'

export const SourceQRCodeCard = ({
	link
}: {
	link: string | null | undefined
}) => {
	if (!link) return
	return (
		<Portal>
			<Card
				sx={{
					position: 'fixed',
					right: 40,
					bottom: 40,
					zIndex: 2000,
					padding: '16px  24px 20px',
					gap: '8px',
					display: 'flex',
					flexDirection: 'column'
				}}
			>
				<Typography fontSize='sm' lineHeight={'32px'} fontWeight='bold'>
					Открыть на устройстве
				</Typography>
				<QRCodeSVG size={280} value={link} />
			</Card>
		</Portal>
	)
}
